import { createApi } from "@reduxjs/toolkit/query/react";
import { getAdminAxiosInstance } from "../../../api/Admin";

const axiosBaseQuery =
  () =>
  async ({ params, endpoint, method, body }) => {
    const api = await getAdminAxiosInstance();
    const getParams = (key) => {
      if (params?.[key]) {
        return `${key}=${params[key]}&`;
      } else {
        return "";
      }
    };
    if (method === "get") {
      try {
        const response = await api[method](
          `${endpoint}?${getParams("start")}${getParams("end")}filter=${
            params?.filter || "all"
          }&${getParams("sort")}sort_order=${
            params?.sort_order || "desc"
          }&per_page=${params?.page_size || "20"}&${getParams("search")}page=${
            params?.page || ""
          }&${getParams("staff_id")}`,
          body
        );
        return { data: response.data };
      } catch (axiosError) {
        let err = axiosError;
        return {
          error: {
            status: err.response?.status,
            data: err.response?.data || err.message,
          },
        };
      }
    } else {
      try {
        const response = await api[method](
          `${endpoint}${getParams("start")}${getParams("end")}${getParams(
            "sort"
          )}${getParams("search")}`,
          body
        );
        return { data: response.data };
      } catch (axiosError) {
        let err = axiosError;
        return {
          error: {
            status: err.response?.status,
            data: err.response?.data || err.message,
          },
        };
      }
    }
  };

export const staff = createApi({
  reducerPath: "staffApi",
  baseQuery: axiosBaseQuery(),
  tagTypes: ["Staff"],
  endpoints: (builder) => ({
    getStaffListData: builder.query({
      query: (values) => ({
        method: "get",
        params: values,
        endpoint: "/staff/index",
      }),
      providesTags: ["Staff"],
    }),
    updateStaffTableHeadData: builder.mutation({
      query: (body) => ({
        method: "post",
        body,
        endpoint: `/user-field/store`,
      }),

      invalidatesTags: ["Staff"],
    }),
    getStaffBasicData: builder.query({
      query: (values) => ({
        method: "get",
        params: values,
        endpoint: "/staff/basic-data",
      }),
      providesTags: ["Staff"],
    }),
    getStaffProfileImage: builder.mutation({
      query: (body) => ({
        method: "post",
        body,
        endpoint: `/staff/upload-image`,
      }),
      providesTags: ["Staff"],
    }),
    updateStaffStatus: builder.mutation({
      query: (body) => ({
        method: "post",
        body,
        endpoint: `staff/change-status`,
      }),
    }),
  }),
});

export const {
  useGetStaffListDataQuery,
  useGetStaffBasicDataQuery,
  useUpdateStaffTableHeadDataMutation,
  useGetStaffProfileImageMutation,
  useUpdateStaffStatusMutation,
} = staff;
